export default __webpack_public_path__ + "static/media/tvShowProject.730191d2.jpg";